import {
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import React from "react";
import { ModalWrapper } from "components/modalWrapper";
import { CheckCircleIcon } from "components/CheckCircleIcon";

interface AwardsModalProps {
  open: boolean;
  onClose: () => void;
}

export const AwardsModal = (props: AwardsModalProps) => {
  const awardsList = [
    "Ter mais liberdade para usar onde e quando quiser",
    "Pagar com cartão físico ou virtual",
    "Usar quando quiser, pois o saldo não expira",
    "Fazer transferências via Pix",
    "Realizar saques e pagar boletos"
  ]

  return (
    <ModalWrapper
      title="Premiações na Caju"
      subtitle="Vá além dos benefícios e presenteie e reconheça seus colaboradores com nossa solução de premiações, sem perder a segurança jurídica e sem misturar com o saldo de benefícios."
      open={props.open}
      handleClose={props.onClose}
    >
      <Paper variant="outlined" sx={{ p: 3, borderRadius: '20px' }}>
        <Typography variant="subtitle2" color="dark.dark" marginBottom={1}>
          O colaborador pode aproveitar:
        </Typography>
        <List>
          {awardsList.map((benefit, index) => (
            <ListItem key={index} sx={{ py: '6px' }}>
              <ListItemIcon>
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText
                primary={benefit}
                primaryTypographyProps={{
                  fontSize: 14,
                  color: "dark.light",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </ModalWrapper>
  );
};
